/**
 * 2026-09-25 (właściciel): skąd okno pakowania bierze zdjęcia pozycji — ustawienie FIRMY
 * (GET/PUT /api/packing/settings, `image_source`): „sellbase" = zdjęcie produktu SellBase (oferta tylko
 * gdy produkt nie ma zdjęcia), „marketplace" = zdjęcie oferty z marketplace jako pierwsze, produkt dalej.
 * Czyste funkcje — testowane w node bez DOM.
 */
export type ZrodloZdjec = 'sellbase' | 'marketplace';

export function zrodloZdjecZKonfigu(v: any): ZrodloZdjec {
  return String(v == null ? '' : v).trim().toLowerCase() === 'marketplace' ? 'marketplace' : 'sellbase';
}

function _lista(v: any): string[] {
  var arr = Array.isArray(v) ? v : [v];
  var out: string[] = [];
  arr.forEach(function(u: any) {
    var s = String(u == null ? '' : u).trim();
    if (s && out.indexOf(s) === -1) out.push(s);
  });
  return out;
}

/** Kolejność zdjęć pozycji: produkt SellBase (jedno lub więcej) i zdjęcie oferty wg źródła. */
export function ulozZdjeciaPozycji(zrodlo: ZrodloZdjec, produkt: any, oferta: any): string[] {
  var p = _lista(produkt);
  var o = _lista(oferta);
  var kolejnosc = zrodlo === 'marketplace' ? o.concat(p) : (p.length ? p : o);
  return kolejnosc.filter(function(u, i, arr) { return arr.indexOf(u) === i; });
}

/**
 * Zdjęcie oferty dla pozycji ze SKŁADU katalogowego (pozycje z /inventory nie niosą zdjęcia oferty):
 * dopasowanie do pozycji zamówienia po offer_id / kluczach źródła / SKU oferty.
 */
export function zdjecieOfertyDlaPozycji(order: any, pos: any): string {
  var it = _pozycjaZamowienia(order, pos, function(x: any) { return !!x.offer_image_url; });
  return it ? String(it.offer_image_url) : '';
}

/** Zgłoszenie #5 (28.10): pozycja zamówienia dla pozycji ze składu katalogowego — to samo dopasowanie co zdjęcie
 *  oferty (offer_id / klucze źródła / SKU oferty); z niej okno pakowania bierze tytuł i adres oferty. */
export function pozycjaZamowieniaDlaPozycji(order: any, pos: any): any {
  return _pozycjaZamowienia(order, pos, function() { return true; });
}

function _pozycjaZamowienia(order: any, pos: any, warunek: (it: any) => boolean): any {
  var items = Array.isArray(order && order.items) ? order.items : [];
  var klucze = _lista([pos && pos.offerId].concat((pos && pos.sourceKeys) || [])).map(function(k) { return k.toLowerCase(); });
  if (!klucze.length) return null;
  for (var i = 0; i < items.length; i++) {
    var it = items[i] || {};
    var kandydaci = _lista([it.offer_id, it.offerId, it.sku, it.product_reference, it.seller_sku, it.external_id])
      .map(function(k) { return k.toLowerCase(); });
    var trafia = klucze.some(function(k) { return kandydaci.indexOf(k) !== -1; });
    if (trafia && warunek(it)) return it;
  }
  return null;
}
